/**
 * R2IT Golf Scoring API
 * This swagger document describes the available API endpoints.
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ModulesGroupsApplicationPairingsPairingSettingsDto { 
    numberOfPlayers?: number;
    numberOfPlayersPerGroup?: number;
    numberOfTees?: number;
    numberOfWaves?: number;
    startingGroupNumber?: number;
    teeTimeInterval?: number;
    startTime?: Date;
    secondWaveStartTime?: Date;
    numberOfAPlayers?: number;
    numberOfCPlayers?: number;
    aGroupPlacement?: string;
    groupNumberSequence?: string;
    handleOddNumberGroupsPerWave?: number;
    handleOddNumberGroupsPerBlock?: number;
    repairByScore?: boolean;
    repairByFlipFlop?: boolean;
    leadersOff10?: boolean;
    invertedType?: string;
    samePairings?: boolean;
    pairingsLastPublished?: Date;
}